/**
 * userUtils.js
 *
 * Shared helper utilities for user attribute checks.
 */

// Determine whether an authenticated user should be treated as an admin
export const isAdmin = (user) => {
  if (!user) return false;

  try {
    const attrs = user.attributes || {};

    const profile = (attrs.profile || attrs['custom:profile'] || attrs['profile'] || '').toString().toLowerCase();
    if (profile === 'admin') return true;

    const customRole = (attrs['custom:role'] || '').toString().toLowerCase();
    if (customRole === 'superadmin') return true;

    const rolesRaw = ((attrs['custom:roles'] || attrs.roles || '') || '').toString().toLowerCase();
    if (rolesRaw.includes('admin')) return true;

    // Fallback: check username contains "admin" (helpful for local/dev testing)
    if (user.username && user.username.toString().toLowerCase().includes('admin')) return true;
  } catch (e) {
    // swallow and return false
  }

  return false;
};

// Maintain default export for backwards compatibility while allowing named imports
export default {
  isAdmin
};
